import { ApiGetIspInformationsLevelsResponse } from './api-get-isp-informations-levels.response';
import con from '../../../../connection';

const path = '/levels';

const levels = (url: string) => () => ({
  get: <
   ResponseType extends ApiGetIspInformationsLevelsResponse
  >(param?: {
    is_valid?: number;
  }) => con.get<ResponseType>(url + path, param || {}),
});

export default levels;